enum LayoutAlign {
  INITIAL = 'initial',
  CENTER = 'center',
  START = 'flex-start',
  END = 'flex-end',
  STRETCH = 'stretch'
}

export default LayoutAlign;
